import React, { Component } from 'react';
import Tabs from './tabs';
import Checkins from './checkins';
import Appointments from './appointments';
import Sales from './sales';

const HISTORY_TABS = {
    APPOINTMENTS: 'appointments',
    ATTENDANCE: 'attendance',
    SALES: 'sales'
};

export default class History extends Component {

    constructor(props) {
        super(props);
        this.state = { tab: HISTORY_TABS.APPOINTMENTS }
    }

    getSelectedTab() {
        if(this.state.tab === HISTORY_TABS.ATTENDANCE) {
            return Checkins;
        } else if (this.state.tab === HISTORY_TABS.APPOINTMENTS) {
            return Appointments;
        } else if (this.state.tab === HISTORY_TABS.SALES) {
            return Sales;
        }
    }

    onTabChange(tab) {
        this.setState({tab: tab})
    }

    render () {
        let SelectedTab = this.getSelectedTab();
        return (
            <div className="container content">
                <Tabs tab={this.state.tab} tabs={HISTORY_TABS} onTabChange={this.onTabChange.bind(this)} />
                <SelectedTab {...this.props} {...this.state} />
            </div>
        );
    }
}

